import { Injectable } from "@angular/core";
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelDataProvider {

  ExcelToJSON = function () {
    this.parseExcel = function (file: File): Promise<string> {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsArrayBuffer(file);

        reader.onload = function (e: ProgressEvent<FileReader>) {
          const data = e.target?.result;
          if (!data) { reject(new Error('Failed to read file')); return; }

          const workbook = XLSX.read(data, { type: 'array' });
          workbook.SheetNames.forEach(function (sheetName: string) {
            const rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
            resolve(JSON.stringify(rows));
          });
        };

        reader.onerror = function (ex) {
          reject(ex);
        };
      });
    };
  };
}
